import { useRequestStore } from "entities/Request";
import { userStore } from "entities/User/store/userStore";
import { RequestHold } from "features/RequestHold";
import { RequestLock } from "features/RequestLock";
import { Card } from "react-bootstrap";
import { serializeObject } from "shared/utils";

function RequestDetailsTopBar() {
  const user = userStore((state) => state.user);
  const request = useRequestStore((state) => state.request);

  const lock = serializeObject(request?.locks?.data);
  const isLocked = lock && lock?.holder_id !== user.id;
  const onHold = serializeObject(request?.onHold?.data);

  return (
    <Card
      className={`text-primary mt-5 pt-2 pb-3 px-3 ${
        isLocked || onHold ? "bg-red text-light" : ""
      }`}
      style={{ marginBottom: "-4rem" }}
    >
      <Card.Body>
        {isLocked ? (
          <RequestLock lock={lock} />
        ) : (
          <RequestHold onHold={onHold} />
        )}
      </Card.Body>
    </Card>
  );
}

export default RequestDetailsTopBar;
